import React from "react";
import Background1 from "../../assets/images/breadcum/01.jpg";
import awards from "../../assets/Upload/Award/3524f1e6-afa8-4d05-9395-e3688b24c3aa.jpg";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import {Col} from "reactstrap"


export default function Awards() {
  const [awardsData, setAwardsData] = useState([]);
  const [groupedAwards, setGroupedAwards] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Make the API call
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getAllAwardMaster`
        );

        // Log the entire response for debugging
        console.log("API Response:", res.data);

        // Check if res.data is an array
        if (Array.isArray(res.data)) {
          // Filter out inactive awards
          const activeAwards = res.data.filter((award) => award.IsActive);

          // Log the filtered active awards
          console.log("Active Awards:", activeAwards);

          // Group awards by year
          const grouped = activeAwards.reduce((acc, award) => {
            const year = award.Year;
            if (!acc[year]) {
              acc[year] = [];
            }
            acc[year].push(award);
            return acc;
          }, {});

          // Sort years in descending order
          const sortedGrouped = Object.keys(grouped)
            .sort((a, b) => b - a)
            .reduce((acc, year) => {
              acc[year] = grouped[year];
              return acc;
            }, {});

          // Set the state with grouped awards
          setGroupedAwards(sortedGrouped);
          setAwardsData(activeAwards);
        } else {
          console.error("API response is not an array");
        }
      } catch (error) {
        console.error("Error fetching awards:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {/* <!-- inner-header --> */}
      <section
        className="inner-banner bg-overlay-black-70 bg-holder"
        style={{ backgroundImage: `url(${Background1})` }}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-12">
              <div className="text-center">
                <h1 className="text-white">Awards</h1>
              </div>
              <div className="d-flex justify-content-center ">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <span>Media Room</span>
                  </li>
                  <li className="breadcrumb-item active">
                    <span>Awards</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-inner-header --> */}
      {/* <!--Our Gallery Section Start --> */}
      <section className="space-ptb award-section">
        <div className="container" style={{ width: '100%', marginLeft: "auto", marginRight: "auto" }}>
          {Object.keys(groupedAwards).map((year, yearIndex) => (
            <div key={yearIndex} className="mb-5">
              {/* Year Heading - Only once per year */}
              <h2 className="year-title mb-4" style={{ color: "#009639", borderBottom: "2px solid #009639", paddingBottom: "10px" }}>
                {year}
              </h2>
              
              {/* Awards for this year */}
              <div className="row">
                {groupedAwards[year].map((award, awardIndex) => (
                  <div className="col-lg-4 col-md-6 mb-4" key={awardIndex}>
                    {award.AwardImage ? (
                      // Award with image
                      <div className="award-card shadow border-radius h-100">
                        <div className="award-img img-container">
                          <img
                            className="w-100 img-fluid img-styled"
                            src={`${process.env.REACT_APP_BASE_API_URL}/${award.AwardImage}`}
                            alt={award.Title}
                            style={{ borderRadius: "5px 5px 0 0", height: "250px", objectFit: "cover" }}
                          />
                        </div>
                        <div className="award-name p-3">
                          <h5 className="text-center mb-0">{award.Title}</h5>
                        </div>
                      </div>
                    ) : (
                      // Award without image
                      <div className="award-card shadow border-radius h-100 p-4 d-flex align-items-center">
                        <div className="award-text w-100">
                          <h5 className="mb-0">
                            <i className="fa fa-trophy" style={{ color: "#009639", marginRight: "10px" }}></i>
                            {award.Title}
                          </h5>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* <!--Our Gallery Section End --> */}
    </>
  );
}
